import BaseApi from 'api/BaseApi';
import { IBaseCalculation } from './CalculationsApi';

export interface IProductCalculation extends IBaseCalculation {
  productId: string;
  createdAt: Date;
  organizationId: string;
  organizationVersion: number | null;
}

export interface IFindProductCalculationsParams {
  productId: string;
  search?: string;
}

export interface IProductCalculationsApi {
  find(params: IFindProductCalculationsParams): Promise<IProductCalculation[]>;
}

export default class ProductCalculationsRestApi extends BaseApi implements IProductCalculationsApi {
  public find(params: IFindProductCalculationsParams): Promise<IProductCalculation[]> {
    const urlSearchParams = new URLSearchParams();

    urlSearchParams.set('productId', params.productId);

    if (params.search) {
      urlSearchParams.set('search', params.search);
    }

    return this.fetch(`/product-calculations?${urlSearchParams}`);
  }
}
